module.exports = __webpack_public_path__ + "img/优势图片.8435ca38.png";